"use client";

import { type FormEvent, useState } from "react";

interface LoginViewProps {
    checking: boolean;
    error: string | null;
    onLogin: (username: string, password: string) => Promise<void>;
}

export function LoginView({ checking, error, onLogin }: LoginViewProps) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [validationError, setValidationError] = useState<string | null>(null);

    async function submit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (username.trim().length < 3) {
            setValidationError("用户名至少 3 位");
            return;
        }
        if (password.length < 6) {
            setValidationError("密码至少 6 位");
            return;
        }
        setValidationError(null);
        setIsSubmitting(true);
        try {
            await onLogin(username, password);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <main className="login-page">
            <section className="login-card" aria-labelledby="login-title">
                <div className="login-brand">
                    <div className="brand-mark">Q</div>
                    <div>
                        <strong>QAScope</strong>
                        <span>ORDER OPERATIONS</span>
                        <small className="company-name">点泽智能科技</small>
                    </div>
                </div>
                <p className="section-kicker">LOCAL ADMIN ACCESS</p>
                <h1 id="login-title">登录管理后台</h1>
                <p className="login-intro">使用本地管理员账号进入单商户跨境订单工作台。凭据只发送至本地后端，不会保存在前端。</p>
                {checking ? (
                    <div className="login-checking" role="status">
                        正在检查登录状态…
                    </div>
                ) : (
                    <form onSubmit={submit}>
                        <label>
                            <span>管理员账号</span>
                            <input
                                autoComplete="username"
                                autoFocus
                                maxLength={64}
                                minLength={3}
                                onChange={(event) => setUsername(event.target.value)}
                                placeholder="请输入管理员账号"
                                required
                                value={username}
                            />
                        </label>
                        <label>
                            <span>密码</span>
                            <input
                                autoComplete="current-password"
                                maxLength={256}
                                minLength={6}
                                onChange={(event) => setPassword(event.target.value)}
                                placeholder="至少 6 位"
                                required
                                type="password"
                                value={password}
                            />
                        </label>
                        {(validationError || error) && (
                            <div className="form-message error" role="alert">
                                {validationError || error}
                            </div>
                        )}
                        <button className="button primary login-submit" disabled={isSubmitting} type="submit">
                            {isSubmitting ? "登录中…" : "登录并进入后台"}
                        </button>
                    </form>
                )}
                <div className="login-boundary">
                    <strong>当前环境边界</strong>
                    <span>本地数据库会话 · HttpOnly Cookie · CSRF 防护</span>
                    <span>生产启用前仍需企业身份、MFA 与登录风控</span>
                </div>
            </section>
        </main>
    );
}
